import { useFetch } from '@reveni-io/reveni-ui'

import commonServices from '@/common/services/services'

const useStoreProductCategories = ({ storeId, doInitialRequest }) => {
  const { data: productCategories, loading: fetchingProductCategories } = useFetch(
    () => commonServices.getStoreProductCategories({ storeId }),
    {
      doInitialRequest: doInitialRequest,
    }
  )

  return {
    productCategories: productCategories || [],
    fetchingProductCategories,
  }
}

export default useStoreProductCategories
